import { WorkflowId } from '../../core/Enums';
import type { TourDefinition } from '../../core/Types';
import { seedModel } from '../../data/Seed';
import { leaseSteps } from './Steps';

export const leaseTour: TourDefinition = {
  id: WorkflowId.LEASE,
  title: 'Lease Tour',
  steps: leaseSteps,
  initialModel: seedModel(),
};
